import loadable from '@loadable/component'
import {getRouter} from 'hiya-common/src/routes'
import anchorcenter from './anchorcenter'
import chat from './chat'
import voteMachine from './voteMachine'
import coinagency from './coinagency'
import crossRoomPk from './crossRoomPk'
import feedback from './feedback'
import game from './game'
import giftBook from './giftBook'
import inviteFission from './inviteFission'
import guildSettled from './guildSettled'
import Helping from './Helping'
import PartyGala from './PartyGala'
import NewUserJoinGuide from './NewUserJoinGuide'
import RedemptionMall from './RedemptionMall'
import hunting from './hunting'
import loginQuestion from './loginQuestion'
import union from './union'
import virtual from './virtual'
import TreasureBox from './TreasureBox'
import wealthLevel from './wealthLevel'
import wallet2 from './wallet2'
import newWallet from './newWallet'
import cardMixture from './cardMixture'
import vip from './vip'
import starGift from './starGift'
import medal from './medal'
import giftWall from './giftWall'
import dressUpBook from './dressUpBook'
import lord from './lord'
import OffSiteRecharge from './OffSiteRecharge'
import buyCoin from './buyCoin'
import powernewuser from './powernewuser'
import TikTok from './TikTok'
import NewAnchorcenter from './NewAnchorcenter'
import secretAdd from './secretAdd'
import LuckyGift from './LuckyGift'
import saada from './saada'
import pk from './pk'
import discontinued from './discontinued'
import MonthlyInfluence from './MonthlyInfluence'
import JoinGuide from './joinGuide'
import CoinAgencyCollectSalary from './CoinAgencyCollectSalary'
import redEnvelope from './redEnvelope'
import IntimateRelationship from './IntimateRelationship'
import svipupdate from './svipupdate'
import code from './code'

const routes = getRouter([
  ...JoinGuide,
  ...OffSiteRecharge,
  ...CoinAgencyCollectSalary,
  ...redEnvelope,
  ...MonthlyInfluence,
  ...IntimateRelationship,
  ...TikTok,
  ...lord,
  ...medal,
  ...giftWall,
  ...dressUpBook,
  ...starGift,
  ...NewAnchorcenter,
  ...secretAdd,
  ...vip,
  ...buyCoin,
  ...pk,
  ...LuckyGift,
  ...voteMachine,
  ...svipupdate,
  {
    path: '/PaidUserUnderTakingGroup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PaidUserUnderTakingGroup" */ '~/pages/PaidUserUnderTakingGroup'
        )
    ),
  },
  {
    path: '/RaceHonorWall',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RaceHonorWall" */ '~/pages/RaceHonorWall'
        )
    ),
  },
  {
    path: '/RaceHonorWall/share',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RaceHonorWall-SharePop" */ '~/pages/RaceHonorWall/components/SharePop'
        )
    ),
  },
  {
    path: '/PersonalDressUp',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PersonalDressUp" */ '~/pages/PersonalDressUp'
        )
    ),
  },
  {
    path: '/FamilyContributeRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FamilyContributeRank" */ '~/pages/FamilyContributeRank'
        )
    ),
  },
  {
    path: '/pendant',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-pendant" */ '~/pages/pendant')
    ),
  },
  {
    path: '/pendantPop',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluence-pendantPop" */ '~/pages/MonthlyInfluence/pages/pendantPop'
        )
    ),
  },
  {
    path: '/FirstCharge',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-FirstCharge" */ '~/pages/FirstCharge')
    ),
  },
  {
    path: '/BlindBoxGift',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BlindBoxGift" */ '~/pages/BlindBoxGift'
        )
    ),
  },
  {
    path: '/LuckyGift',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LuckyGift" */ '~/pages/LuckyGift')
    ),
  },
  ...wallet2,
  ...newWallet,
  ...virtual,
  ...TreasureBox,
  ...wealthLevel,
  {
    path: '/SongRoomTaskCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SongRoomTaskCenter" */ '~/pages/SongRoomTask/TaskCenter'
        )
    ),
  },
  {
    path: '/SnatchSingPlay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SnatchSingPlay" */ '~/pages/SnatchSingPlay'
        )
    ),
  },
  {
    path: '/SongRoomSingerRankList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SongRoomSingerRankList" */ '~/pages/SongRoomTask/RankList'
        )
    ),
  },
  {
    path: '/UnionPK',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UnionPK" */ '~/pages/UnionPK')
    ),
  },
  {
    path: '/FamilyPk',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-FamilyPk" */ '~/pages/FamilyPk')
    ),
  },
  {
    path: '/FamilyPkRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewBIgR-rule" */ '~/pages/FamilyPk/rule'
        )
    ),
  },
  {
    path: '/newbigr',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-NewBIgR" */ '~/pages/NewBIgR')
    ),
  },
  ...game,
  {
    path: '/GeneralLottery',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GeneralLottery" */ '~/pages/GeneralLottery'
        )
    ),
  },
  {
    path: '/bigr',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-BigR" */ '~/pages/BigR')
    ),
  },
  {
    path: '/Share',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Share" */ '~/pages/Share')
    ),
  },
  {
    path: '/hiyashareact/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Share-Out" */ '~/pages/Share/LoadingPage'
        )
    ),
  },
  {
    path: '/hiyashareroom/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Share-hiyaRoom" */ '~/pages/Share/RoomShare'
        )
    ),
  },
  {
    path: '/unionTask',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UnionTask" */ '~/pages/UnionTask')
    ),
  },
  {
    path: '/unionTask3',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-UnionTask3" */ '~/pages/UnionTask3')
    ),
  },
  {
    path: '/unionTask3/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionTask3-rank" */ '~/pages/UnionTask3/Rank'
        )
    ),
  },
  {
    path: '/doubleroomtask',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTask" */ '~/pages/DoubleRoomTask'
        )
    ),
  },
  {
    path: '/doubleroomtask/recruit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTaskRecruit" */ '~/pages/DoubleRoomTask/recruit'
        )
    ),
  },
  {
    path: '/doubleroomtask/board',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTask-board" */ '~/pages/DoubleRoomTask/board'
        )
    ),
  },
  {
    path: '/send',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Send" */ '~/pages/Send')
    ),
  },
  {
    path: '/UserInfoCollection',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UserInfoCollection" */ '~/pages/UserInfoCollection'
        )
    ),
  },
  {
    path: '/AnchorTaskSystem',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorTaskSystem" */ '~/pages/AnchorTaskSystem'
        )
    ),
  },
  {
    // 首页排行榜
    path: '/CoreRanking',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-CoreRanking" */ '~/pages/CoreRanking')
    ),
  },
  {
    // 首页排行榜
    path: '/HeatPointRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HeatPointRank" */ '~/pages/HeatPointRank'
        )
    ),
  },
  {
    // 首页排行榜
    path: '/HeatPointRank/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HeatPointRankDetail" */ '~/pages/HeatPointRank/detail'
        )
    ),
  },
  {
    // 贵族/体验贵族 领取页
    path: '/NormalVipActive',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NormalVipActive" */ '~/pages/NormalVipActive'
        )
    ),
  },
  {
    // 自动跳转udesk
    path: '/Udesk',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-GoUdesk" */ '~/pages/GoUdesk')
    ),
  },
  // otherInfo携带邀请公会id m_union_id
  {
    path: '/Talent/invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentApply-invitation" */ '~/pages/TalentApply/invitation'
        )
    ),
  },
  {
    path: '/TalentApply',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-TalentApply" */ '~/pages/TalentApply')
    ),
  },
  {
    // 印尼新公会任务
    path: '/IdUnionTask',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-IdUnionTask" */ '~/pages/IdUnionTask')
    ),
  },
  {
    // 私信页面活动分享页面
    path: '/activity-sharing',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-activity-sharing" */ '~/pages/ActivitySharing'
        )
    ),
  },
  {
    // 房间内分享
    path: '/room-share/:id',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-room-share" */ '~/pages/RoomShare')
    ),
  },
  ...chat,
  ...feedback,
  ...hunting,
  ...coinagency,
  ...crossRoomPk,
  ...union,
  ...PartyGala,
  ...Helping,
  ...NewUserJoinGuide,
  ...RedemptionMall,
  ...anchorcenter,
  ...loginQuestion,
  ...guildSettled,
  ...giftBook,
  ...inviteFission,
  ...cardMixture,
  ...powernewuser,
  ...saada,
  ...code,
  {
    path: '/task-center',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-task-center" */ '~/pages/TaskCenter')
    ),
  },
  ...discontinued, // 此内路由本身已经删除，但是因为历史消息等原因仍会造成用户访问造成404，故此路由进行兜底
])

export default (store) => routes
// import game from './game'
//
// export default (store) => getRouter([...game])
